define('components/asset-player/collections/media-files',[
    'components/boilerplate/collections/base',
    'components/asset-player/models/media-file'
], function (Base, MediaFile) {
    "use strict";

    return Base.extend({
        "model": MediaFile
    });
});

